// extracted by mini-css-extract-plugin
export var container = "styles-module--container--McgJX";
export var center = "styles-module--center--HL9LM";
export var imgStair = "styles-module--imgStair--mkLo9";
export var title = "styles-module--title--vGImr";
export var wrapperFeatures = "styles-module--wrapperFeatures--v-Gs4";
export var feature = "styles-module--feature--wYv-m";
export var textGreen = "styles-module--textGreen--3QgDf";